<template>
    <Row class="courseClass content">
        <Spin fix v-if="loading"></Spin>
        <Form inline :label-width="85" :model="formValidate">
            <FormItem label="微信昵称：">
                <Input v-model="formValidate.wxName" placeholder="请输入微信昵称"></Input>
            </FormItem>
            <FormItem label="手机号码：">
                <Input v-model="formValidate.telnum" placeholder="请输入手机号"></Input>
            </FormItem>
            <FormItem label="期数：">
                <Input v-model="formValidate.seasonNumber" placeholder="请输入期数"></Input>
            </FormItem>
            <FormItem label="开课日期：">
                <DatePicker
                    type="date"
                    placeholder="请选择开课日期"
                    style="width: 100%"
                    v-model="formValidate.unlockTime"
                ></DatePicker>
            </FormItem>
            <FormItem label="班级：">
                <Input v-model="formValidate.goodsName" placeholder="请输入班级名称" />
            </FormItem>
            <FormItem label="解锁天数：" class="from_item">
                <Input class="input" v-model="formValidate.unlockDays" />&nbsp;
                <span class="span_xian"></span> &nbsp;
                <Input class="input" v-model="formValidate.unlockDays" />
            </FormItem>
            <FormItem label="完课天数：" class="from_item">
                <Input class="input" v-model="formValidate.dayNum" />&nbsp;
                <span class="span_xian"></span> &nbsp;
                <Input class="input" v-model="formValidate.dayNum" />
            </FormItem>
            <!--<FormItem label="打卡天数：" class="from_item">-->
            <!--<Input class="input" v-model="formValidate.num1"/>&nbsp;<span class="span_xian"></span> &nbsp;<Input class="input" v-model="formValidate.num2"/>-->
            <!--</FormItem>-->
        </Form>
        <div class="btn_div">
            <Button type="primary" @click="screen()">筛选</Button>
            <Button @click="reset()" style="margin-left: 40px">重置</Button>
            <Button type="warning" style="margin-left: 40px" @click="clickExport()">导出</Button>
        </div>
        <div class="step_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="classList"></Table>
            <div>
                <page-component
                    class="page"
                    :total-num="totalNum"
                    :page-num="pageNum"
                    v-on:changePage="changePage"
                    v-on:changePageSize="changePageSize"
                    v-on:clickPage="clickPage"
                ></page-component>
            </div>
        </div>
    </Row>
</template>
<style scoped>
.courseClass > div {
    padding: 10px 0;
}
.from_item {
    width: 25%;
}
.input {
    max-width: 25% !important;
}
.span_xian {
    display: inline-block;
    width: 30px;
    height: 1px;
    background: #000;
}
.btn_div {
    text-align: center;
}
.page {
    margin-top: 20px;
}
</style>
<script>
import { Upload, DatePicker } from "iview";
import pageComponent from "../common/page.vue";
import util from "../../libs/util.js";
import http from "../../libs/http.js";
export default {
    components: {
        DatePicker,
        Upload,
        pageComponent
    },
    data() {
        return {
            classList: [],
            courseId: this.$route.query.courseId,
            columns: [
                {
                    type: "index",
                    title: "NO.",
                    width: 60,
                    align: "center"
                },
                {
                    title: "期数",
                    key: "seasonNumber",
                    align: "center",
                    render: (h, params) => {
                        return h("span", "第" + params.row.seasonNumber + "期");
                    }
                },
                //                    {
                //                        title: '班级',
                //                        key: 'teacherName',
                //                        align: 'center',
                //                        render: (h, params) => {
                //                            return h("span", params.row.classNumber+'班');
                //                        }
                //
                //                    },
                {
                    title: "老师名称",
                    key: "teacherName",
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.teacherName
                                ? params.row.teacherName
                                : "无"
                        );
                    }
                },
                {
                    title: "微信昵称",
                    key: "wxName",
                    align: "center"
                },
                {
                    title: "手机号码",
                    key: "telnum",
                    align: "center"
                },
                //                    {
                //                        title: '用户名',
                //                        key: 'name',
                //                        align: 'center'
                //                    },
                {
                    title: "开课时间",
                    key: "unlockTime",
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "span",
                            util.timestampToTime(params.row.unlockTime)
                        );
                    }
                },
                {
                    title: "激活时间",
                    key: "activeTime",
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "span",
                            util.timestampToTime(params.row.activeTime)
                        );
                    }
                },
                {
                    title: "解锁天数",
                    key: "unlockDays",
                    align: "center",
                    render: (h, params) => {
                        return h("span", params.row.unlockDays + "天");
                    }
                },
                {
                    title: "完课天数",
                    key: "dayNum",
                    align: "center",
                    render: (h, params) => {
                        return h("span", params.row.dayNum + "天");
                    }
                },
                {
                    title: "学习时长",
                    key: "action",
                    align: "center",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small"
                                    },
                                    style: {
                                        marginRight: "2px"
                                    },
                                    on: {
                                        click: () => {
                                            this.editPf(params.row);
                                        }
                                    }
                                },
                                "详情"
                            )
                        ]);
                    }
                }
                //                    {
                //                        title: '打卡天数',
                //                        key: 'dayNumber',
                //                        align: 'center'
                //                    }
            ],
            loading: false,
            formValidate: {},
            totalNum: 0,
            pageNum: 1,
            pageSize: 10
        };
    },
    created() {
        this.getClass(this.pageNum, this.pageSize);
    },
    methods: {
        //当前页数
        changePage(data) {
            this.pageNum = data;
            this.getClass(this.pageNum, this.pageSize);
        },
        //点击切换页数
        clickPage(data) {
            this.pageNum = data;
            this.getClass(this.pageNum, this.pageSize);
        },
        //当前每页显示的条数
        changePageSize(data) {
            this.pageSize = data;
            this.getClass(this.pageNum, this.pageSize);
        },
        //筛选
        screen() {},
        //重置
        reset() {},
        //导出
        clickExport() {},
        //详情
        editPf(id) {},
        //获取学习进度-年课
        getClass(num, pageSize) {
            let _this = this;
            http.post("/custom/stat/study", {
                courseId: _this.courseId,
                pageNum: num,
                pageSize: pageSize
            }).then(res => {
                if (num > res.pages && res.pages != 0) {
                    _this.pageNum = res.pages;
                    _this.getClass(res.pages, pageSize);
                } else {
                    _this.classList = res.list;
                    _this.totalNum = res.total;
                }
            });
        },
        //导出
        clickExport() {
            let that = this;
            var _data = {
                courseId: that.courseId
            };
            http.blob("/custom/stat/studyExport", _data).then(res => {
                util.downloadFile("年课.xlsx", res.data);
            });
        }
    }
};
</script>
